// Veri Girişi Değerleri (/data-entry-values). Listelerdeki değerler kayıtlı
// değerlerdir ve yazıldığı gibi gösterilir.
const dataEntryValues = {
  page: {
    title: 'Veri Girişi Değerleri',
    subtitle: 'Formlarda seçilen departman, yetki rolü, gelir ve gider değerlerinin listeleri.',
  },
  stats: {
    lists: 'Değer Listesi',
    listsShort: 'Liste',
    active: 'Aktif Değer',
    activeShort: 'Aktif',
    passive: 'Pasif Değer',
    passiveShort: 'Pasif',
    unsaved: 'Kaydedilmemiş Liste',
    unsavedShort: 'Kaydedilmemiş',
  },
  groups: {
    people: 'Çalışan ve yetkilendirme',
    income: 'Gelir',
    expense: 'Gider yönetimi',
  },
  card: {
    active: '{{count}} aktif',
    passive: '{{count}} pasif',
    unsaved: 'Kaydedilmemiş değişiklik',
    activeShort: 'Aktif',
    passiveShort: 'Pasif',
    makePassive: 'Pasif yap (yeni kayıtlarda seçilemez)',
    makeActive: 'Aktif yap',
    edit: 'Düzenle',
    doneEditing: 'Düzenlemeyi bitir',
    delete: 'Sil',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
  },
  validation: {
    duplicate: 'Bu değer zaten listede mevcut.',
  },
  confirm: {
    deactivateTitle: 'Değer kullanımda',
    deleteTitle: 'Değer silinsin mi?',
    deactivate: 'Pasif duruma getir',
    delete: 'Sil',
    cancel: 'İptal',
  },
  toast: {
    loadError: '{{name}} yüklenirken bir hata oluştu.',
    saved: '{{name}} başarıyla kaydedildi!',
    saveError: '{{name}} kaydedilirken bir hata oluştu: {{message}}',
    checkValues: 'Lütfen girdiğiniz değerleri kontrol edin.',
    checkError: '{{name}} için kullanım kontrolü yapılırken bir hata oluştu.',
  },
  lists: {
    departments: {
      name: 'Departmanlar',
      title: 'Çalışan Menü – Departmanlar',
      helper: 'Çalışanlar için mevcut departmanları düzenleyin. Boş departmanlar kaydedilmeyecektir.',
      placeholder: 'Departman adı giriniz',
      itemName: 'Departman {{index}}',
      add: 'Yeni Ekle',
      deactivated: 'Departman pasif duruma getirildi.',
      deleted: 'Departman başarıyla silindi.',
      inUse: 'Bu departman ({{value}}) çalışanlara atanmış durumda. Silmek yerine pasif duruma getirmek ister misiniz? Pasif departmanlar listede görünmeye devam edecek ancak yeni çalışanlar için seçilemeyecektir.',
      deleteMessage: '“{{value}}” departmanını silmek istediğinizden emin misiniz? Liste hemen kaydedilir.',
    },
    roles: {
      name: 'Yetkilendirme rolleri',
      title: 'Yetkilendirme Rolleri',
      helper: 'Sistem kullanıcıları için yetkilendirme rollerini düzenleyin. Boş roller kaydedilmeyecektir.',
      placeholder: 'Rol adı giriniz',
      itemName: 'Rol {{index}}',
      add: 'Yeni Ekle',
      deactivated: 'Rol pasif duruma getirildi.',
      deleted: 'Rol başarıyla silindi.',
      inUse: 'Bu rol ({{value}}) kullanıcılara atanmış durumda. Silmek yerine pasif duruma getirmek ister misiniz? Pasif roller listede görünmeye devam edecek ancak yeni kullanıcılar için seçilemeyecektir.',
      deleteMessage: '“{{value}}” rolünü silmek istediğinizden emin misiniz? Liste hemen kaydedilir.',
    },
    incomeSources: {
      name: 'Gelir kaynakları',
      title: 'Gelir Kaynakları',
      helper: 'Gelir kaynaklarını düzenleyin. Boş kaynaklar kaydedilmeyecektir.',
      placeholder: 'Gelir kaynağı giriniz',
      itemName: 'Gelir kaynağı {{index}}',
      add: 'Yeni Ekle',
      deactivated: 'Gelir kaynağı pasif duruma getirildi.',
      deleted: 'Gelir kaynağı başarıyla silindi.',
      inUse: 'Bu gelir kaynağı ({{value}}) bütçe kayıtlarında kullanılıyor. Silmek yerine pasif duruma getirmek ister misiniz? Pasif gelir kaynakları listede görünmeye devam edecek ancak yeni kayıtlar için seçilemeyecektir.',
      deleteMessage: '“{{value}}” gelir kaynağını silmek istediğinizden emin misiniz? Liste hemen kaydedilir.',
    },
    incomeCategories: {
      name: 'Gelir kategorileri',
      title: 'Gelir Kategorileri',
      helper: 'Gelir kategorilerini düzenleyin. Boş kategoriler kaydedilmeyecektir.',
      placeholder: 'Gelir kategorisi giriniz',
      itemName: 'Gelir kategorisi {{index}}',
      add: 'Yeni Ekle',
      deactivated: 'Gelir kategorisi pasif duruma getirildi.',
      deleted: 'Gelir kategorisi başarıyla silindi.',
      inUse: 'Bu gelir kategorisi ({{value}}) bütçe kayıtlarında kullanılıyor. Silmek yerine pasif duruma getirmek ister misiniz? Pasif gelir kategorileri listede görünmeye devam edecek ancak yeni kayıtlar için seçilemeyecektir.',
      deleteMessage: '“{{value}}” gelir kategorisini silmek istediğinizden emin misiniz? Liste hemen kaydedilir.',
    },
    expenseSources: {
      name: 'Gider kaynakları',
      title: 'Gider Kaynakları',
      helper: 'Gider kaynaklarını düzenleyin; değişiklikler “Kaydet” ile yazılır.',
      placeholder: 'Gider kaynağı',
      itemName: 'Gider kaynağı {{index}}',
      add: 'Yeni Gider Kaynağı Ekle',
    },
    expenseTypes: {
      name: 'Gider tipleri',
      title: 'Gider Tipleri',
      helper: 'Gider tiplerini düzenleyin; değişiklikler “Kaydet” ile yazılır.',
      placeholder: 'Gider tipi',
      itemName: 'Gider tipi {{index}}',
      add: 'Yeni Gider Tipi Ekle',
    },
    expenseCategories: {
      name: 'Gider kategorileri',
      title: 'Gider Kategorileri',
      helper: 'Gider kategorilerini düzenleyin; değişiklikler “Kaydet” ile yazılır.',
      placeholder: 'Gider kategorisi',
      itemName: 'Gider kategorisi {{index}}',
      add: 'Yeni Gider Kategorisi Ekle',
    },
  },
};

export default dataEntryValues;
